// extracted by mini-css-extract-plugin
var _1 = "F7c1u";
var _2 = "i7sXU";
var _3 = "WhyVs";
var _4 = "Xsjy4";
export { _1 as "button", _2 as "defaultButton", _3 as "ghost", _4 as "primary" }
